// import components
import {
  StyledDutyLineList,
  StyledOptionLabelBox
} from './UncontrolledDutyLineList.styles';

// import types
import { UncontrolledListProps } from './UncontrolledList.types';

const UncontrolledList = ({ option, ...props }: UncontrolledListProps) => {
  return (
    <StyledDutyLineList {...props}>
      <StyledOptionLabelBox>{option.label}</StyledOptionLabelBox>
    </StyledDutyLineList>
  );
};

export default UncontrolledList;
